export const DRAG_MIME_TYPE = 'application/x-prodgy-dashboard-base-id';
